

import useTranslations from "../../../providers/useTranslations";

import { formatPrice } from "../../../lib/utils";

const ProductListItem = (props) => {

  const { addItemToCart, optionsFirst,
    categories,
    isOffer,
    removeItem,
    setItemQuantity,
    selectedMenu,
    product,
    setSelectedProduct } = props;

  const [displayPrice, setDisplayPrice] =React.useState(product.price)

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  const getDisplayedBasePrice = () => {
    // if this is a combo product and the price is 0 then display a message
    if (isOffer) {
      return tr("Only available in the XooNoo mobile app")
    }
    if (displayPrice == 0) {
      return tr("Price may vary")
    }
    //return `${props.priceUnit}${displayPrice}`
    return formatPrice(displayPrice)
  }

  const mediaImageDiv = () => {
    return (
      <div className={"p-1 br-3 product-grid-item " }>

        <div className="media product-list-item" onClick={() => {
          setSelectedProduct(product)
        }} >
          {props.image ?
            <img className={props.imageClass} src={props.image} alt={props.imageAlt} style={{ borderRadius: 5,  width: "80%" }} />
            :
            <div className="mr-3"><i  className={" icofont-ui-press text-" + props.badgeVariant + " food-item"} /></div>
          }
          <div className="media">
            <h6 className="mb-1">{props.title} {props.showBadge ? <Badge variant={props.badgeVariant}>{props.badgeText}</Badge> : ""}</h6>
            <p className="text-gray mb-0">{getDisplayedBasePrice()}</p>
          </div>
        </div >

      </div>
    );

  }

  //console.log("ProductListItem with props", props)

  return (
    <div className={"p-1 product-grid-item " }>

      <div className='product-list-item' onClick={() => {
        //console.log("ProductListItem onClick", product)
        setSelectedProduct(product)
      }} >
        <div className='product-list-item-image'>
        {props.image ?
          <img className={props.imageClass} src={props.image} alt={props.imageAlt}  />
          :
          <div className="mr-3"><i className={"icofont-ui-press text-" + props.badgeVariant + " food-item"} /></div>
        }
        </div>
        <div className="p-1">
          <h6 className="mb-1">{props.title} {props.showBadge ? <Badge variant={props.badgeVariant}>{props.badgeText}</Badge> : ""}</h6>
          <span className="text-gray mb-0 intl-formatted-price">{getDisplayedBasePrice()}</span>
        </div>
      </div>

    </div>
  );


}

export default ProductListItem